const { createSlice } = require("@reduxjs/toolkit");

const onboardingFormSlice = createSlice({
    name: "formSlice",
    initialState: {
        step: 1
    },
    reducers: {
        goNext: (state) => { state.step += 1 },
        goBack: (state) => { if (state.step > 1) state.step -= 1 },
        goThrSideBar: (state, action) => {
            state.step = action.payload
        },
    }
});

export const { goNext, goBack, goThrSideBar } = onboardingFormSlice.actions;
export default onboardingFormSlice.reducer;